import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
    import { THGTag } from '@/interfaces/thg/THGTag';
    import { fetchTHGTags } from '@/api/thg/tags';
    import { BComponent } from 'buefy/types/components';
    import THGTagChip from '@/components/thg/THGTagChip.vue';

    interface Props {
        value: THGTag[];
        labelText?: string;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGTagInput',
  props: {
    value: null,
    labelText: { default: 'Tags' }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
        (e: 'input', tags: THGTag[]): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as { value: THGTag[], labelText: string };

    let data: THGTag[] = [];
    const filteredTags = ref<THGTag[]>();
    const taginput = ref<BComponent>();

    

    

    const tags = computed<THGTag[]>({
        get() {
            return props.value;
        },
        set(newVal: THGTag[]) {
            emit('input', newVal);
        },
    });

    const removeTag = (index: number | string, ev: Event) => {
        if (taginput.value) {
            taginput.value.removeTag(index, ev);
        }
    };

    const getFilteredTags = (text: string) => {
        // filter the tags while typing
        filteredTags.value = data.filter((option) => {
            if (option.name) {
                return option.name.toLowerCase().indexOf(text.toLowerCase()) >= 0;
            }
        });
    };

    onMounted(async () => {
        // fetch tags on mounted
        const resp = await fetchTHGTags();

        if (!resp.parsedBody) {
            throw new Error('Cannot retrieve tags.');
        }

        data = resp.parsedBody;
        filteredTags.value = data;
    });

return { __sfc: true,data, filteredTags, taginput, props, emit, tags, removeTag, getFilteredTags, THGTagChip }
}

})